import { useTranslations } from 'use-intl'

interface ShopStoryProps {
  description: string | null
}

export function ShopStory({ description }: ShopStoryProps) {
  const t = useTranslations('shopDetail.story')

  if (!description) return null

  return (
    <section className="w-full pb-8">
      <div className="flex items-center gap-4 mb-6">
        <div className="h-[1px] w-12 bg-primary"></div>
        <h3 className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary">
          {t('title', { defaultValue: 'About this Restaurant' })}
        </h3>
      </div>
      
      <div className="bg-surface-container-low p-6 md:p-8 rounded-2xl border border-outline-variant/20 shadow-sm relative overflow-hidden">
        {/* Decorative quote mark */}
        <div className="absolute -top-4 -left-2 text-9xl text-primary/5 font-serif leading-none select-none pointer-events-none">
          "
        </div>
        
        <div className="relative z-10">
          <p className="text-base md:text-lg text-on-surface-variant leading-relaxed md:leading-loose font-['Noto_Sans_JP'] tracking-wide">
            {description}
          </p>
        </div>
      </div>
    </section>
  )
}
